module.exports = __webpack_public_path__ + "static/media/introduce_p3@2x.497c0331.png";